/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import RectangleShimmer from './views/rectangle-shimmer';
import RoundShimmer from './views/round-shimmer';

export const ShimmerShapes = {
  ROUND: 'round',
  RECTANGLE: 'rectangle',
};

export const ShimmerAnimation = {
  SHIMMER: 'shimmer',
};

export const ShimmerAnimationClass = {
  [ShimmerAnimation.SHIMMER]: 'shimmer-animation-one',
};

export const ShimmerColors = {
  gray200: 'gray200',
  gray100: 'gray100',
  primary100: 'primary100',
};

export const ShimmerColorClass = {
  [ShimmerColors.gray100]: 'shimmer-gray-100',
  [ShimmerColors.gray200]: 'shimmer-gray-200',
  [ShimmerColors.primary100]: 'shimmer-primary-100',
};

export const getShimmerMap = (args) => ({
  [ShimmerShapes.RECTANGLE]: <RectangleShimmer {...args} />,
  [ShimmerShapes.ROUND]: <RoundShimmer {...args} />,
});
